<form *ngIf="brightnessForm" [formGroup]="brightnessForm" class="custom">
  <mat-slide-toggle
    formControlName="brightnessControl"
    color="primary"
    matTooltip="{{ 'pages.tables.actions.brightnessControl' | translate }}"
  >
    <span *ngIf="!this.brightnessForm.get('brightnessControl')?.value">{{ 'pages.tables.actions.brightnessControl' | translate }}</span>
  </mat-slide-toggle>
  <div *ngIf="this.brightnessForm.get('brightnessControl')?.value" class="control_wrapper">
    <div class="level_wrapper" matTooltip="{{ 'pages.tables.content.brightnessDesc' | translate }}">
      <mat-label>{{ 'pages.tables.content.brightnessLevel' | translate }}:</mat-label>
      <input
        type="number"
        class="level__input"
        [formControl]="brightnessLevelControl"
        min="40"
        max="100"
        (input)="enforceMaxLength($event)"
      />
      <mat-error *ngIf="brightnessLevelControl?.errors">
        {{ 'period.errors.level' | translate }}
      </mat-error>
    </div>

    <mat-slider
      color="primary"
      [formControl]="brightnessLevelControl"
      min="40"
      max="100"
      step="1"
      thumbLabel
    >
      <input matSliderThumb>
      <mat-label>Brightness level</mat-label>
    </mat-slider>
    <button class="btn btn__primary btn__icon btn__brightness" (click)="brightnessSchedule()" [disabled]="isDisabledForm">
      <span class="add">{{ 'pages.tables.actions.brightnessSchedule' | translate }}</span>
    </button>
  </div>
</form>
